import { ChangeDetectionStrategy, Component, type ElementRef, Input, ViewChild } from '@angular/core';
import { SharedPipesModule } from '@reconcept-platform/shared/util';

@Component({
  selector: 'rcp-file-preview-audio',
  template: `
    <audio controls [src]="previewFileURL | safeSrc" #player>
      <a [href]="previewFileURL"> Download audio </a>
    </audio>
  `,
  imports: [SharedPipesModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FilePreviewAudioComponent {
  @Input()
  previewFileURL: string;

  @ViewChild('player')
  player: ElementRef;

  pause() {
    this.player?.nativeElement?.pause();
  }
}
